import React, { PureComponent } from 'react';

export default class CustomizedLabel extends PureComponent {
    render() {
      const {
        stroke, value, angle
      } = this.props;
      const { x, y } = this.props.viewBox;
      return <text x={x + 25} y={y} dy={0} angle={angle} fill="white" fontSize={12} textAnchor="middle">{value}</text>;
    }
  }


// WEBPACK FOOTER //
// ./src/components/AreaChart/CustomizedLabel.js